// 8 départements d'Île-de-France — landing pages SEO par métier
export const DEPARTMENTS = {
  paris: {
    code: "75",
    name: "Paris",
    label: "Paris (75)",
    prep: "à Paris",
    hero: "à Paris",
    region: "Île-de-France",
    cities: [
      "Paris 1er", "Paris 2e", "Paris 3e", "Paris 4e", "Paris 5e",
      "Paris 6e", "Paris 7e", "Paris 8e", "Paris 9e", "Paris 10e",
      "Paris 11e", "Paris 12e", "Paris 13e", "Paris 14e", "Paris 15e",
      "Paris 16e", "Paris 17e", "Paris 18e", "Paris 19e", "Paris 20e",
    ],
    quartiers: ["Le Marais", "Bastille", "Montmartre", "Belleville", "Batignolles", "Saint-Germain-des-Prés", "Champs-Élysées"],
    mapEmbed: "https://www.google.com/maps?q=Paris%2C%20France&z=11&output=embed",
    contexte: "capitale ultra-dense",
    specificites: "immeubles haussmanniens, copropriétés anciennes, sous-sols exigus, gardiens d'immeuble, digicodes, cours d'immeubles",
  },
  yvelines: {
    code: "78",
    name: "Yvelines",
    label: "Yvelines (78)",
    prep: "dans les Yvelines",
    hero: "dans les Yvelines",
    region: "Île-de-France",
    cities: [
      "Versailles", "Saint-Germain-en-Laye", "Poissy", "Mantes-la-Jolie", "Sartrouville",
      "Trappes", "Houilles", "Conflans-Sainte-Honorine", "Les Mureaux", "Vélizy-Villacoublay",
      "Chatou", "Le Chesnay-Rocquencourt", "Le Vésinet", "Maisons-Laffitte", "Saint-Cyr-l'École",
      "Rambouillet", "Montigny-le-Bretonneux", "Guyancourt", "Élancourt", "Voisins-le-Bretonneux",
    ],
    quartiers: ["Versailles château", "Saint-Germain-en-Laye centre", "Poissy centre", "Vélizy 2", "vallée de Chevreuse"],
    mapEmbed: "https://www.google.com/maps?q=Yvelines%2C%20France&z=9&output=embed",
    contexte: "département mixte urbain/pavillonnaire",
    specificites: "pavillons individuels, résidences des Trente Glorieuses, communes rurales, écarts entre communes",
  },
  essonne: {
    code: "91",
    name: "Essonne",
    label: "Essonne (91)",
    prep: "en Essonne",
    hero: "en Essonne",
    region: "Île-de-France",
    cities: [
      "Évry-Courcouronnes", "Corbeil-Essonnes", "Massy", "Palaiseau", "Savigny-sur-Orge",
      "Sainte-Geneviève-des-Bois", "Draveil", "Yerres", "Les Ulis", "Athis-Mons",
      "Viry-Châtillon", "Grigny", "Ris-Orangis", "Longjumeau", "Étampes",
      "Brétigny-sur-Orge", "Vigneux-sur-Seine", "Chilly-Mazarin", "Morsang-sur-Orge", "Fleury-Mérogis",
    ],
    quartiers: ["plateau de Saclay", "vallée de l'Orge", "grand Évry", "Massy TGV", "sud Essonne"],
    mapEmbed: "https://www.google.com/maps?q=Essonne%2C%20France&z=9&output=embed",
    contexte: "département sud francilien",
    specificites: "résidences des années 70-80, pavillons, zones pavillonnaires étendues, chauffage collectif fréquent",
  },
  "seine-et-marne": {
    code: "77",
    name: "Seine-et-Marne",
    label: "Seine-et-Marne (77)",
    prep: "en Seine-et-Marne",
    hero: "en Seine-et-Marne",
    region: "Île-de-France",
    cities: [
      "Meaux", "Melun", "Chelles", "Pontault-Combault", "Torcy",
      "Champs-sur-Marne", "Fontainebleau", "Provins", "Coulommiers", "Bussy-Saint-Georges",
      "Savigny-le-Temple", "Roissy-en-Brie", "Lagny-sur-Marne", "Nemours", "Ozoir-la-Ferrière",
      "Le Mée-sur-Seine", "Combs-la-Ville", "Vaires-sur-Marne", "Dammarie-les-Lys", "Brie-Comte-Robert",
    ],
    quartiers: ["Val d'Europe", "Marne-la-Vallée", "Meaux centre", "Melun préfecture", "sud Seine-et-Marne"],
    mapEmbed: "https://www.google.com/maps?q=Seine-et-Marne%2C%20France&z=9&output=embed",
    contexte: "plus vaste département francilien, mix urbain et rural",
    specificites: "grandes distances entre communes, longères et fermes rénovées, résidences neuves à Val d'Europe, secteur rural étendu",
  },
  "hauts-de-seine": {
    code: "92",
    name: "Hauts-de-Seine",
    label: "Hauts-de-Seine (92)",
    prep: "dans les Hauts-de-Seine",
    hero: "dans les Hauts-de-Seine",
    region: "Île-de-France",
    cities: [
      "Boulogne-Billancourt", "Nanterre", "Courbevoie", "Colombes", "Neuilly-sur-Seine",
      "Levallois-Perret", "Asnières-sur-Seine", "Rueil-Malmaison", "Antony", "Clichy",
      "Issy-les-Moulineaux", "Meudon", "Suresnes", "Puteaux", "Bagneux",
      "Châtenay-Malabry", "Malakoff", "Sceaux", "Clamart", "Le Plessis-Robinson",
    ],
    quartiers: ["La Défense", "Boulogne bord de Seine", "Neuilly avenue Charles-de-Gaulle", "Sceaux centre", "Issy Val de Seine"],
    mapEmbed: "https://www.google.com/maps?q=Hauts-de-Seine%2C%20France&z=10&output=embed",
    contexte: "département résidentiel et tertiaire haut de gamme",
    specificites: "immeubles récents, résidences de standing, tours de bureaux à La Défense, copropriétés soignées, exigence de qualité",
  },
  "seine-saint-denis": {
    code: "93",
    name: "Seine-Saint-Denis",
    label: "Seine-Saint-Denis (93)",
    prep: "en Seine-Saint-Denis",
    hero: "en Seine-Saint-Denis",
    region: "Île-de-France",
    cities: [
      "Saint-Denis", "Montreuil", "Aubervilliers", "Aulnay-sous-Bois", "Drancy",
      "Noisy-le-Grand", "Bondy", "Bagnolet", "Épinay-sur-Seine", "Livry-Gargan",
      "Pantin", "Les Lilas", "Le Blanc-Mesnil", "Sevran", "Neuilly-sur-Marne",
      "Rosny-sous-Bois", "Villepinte", "Noisy-le-Sec", "Stains", "Tremblay-en-France",
    ],
    quartiers: ["Plaine Saint-Denis", "Montreuil bas", "Aubervilliers Fort", "Bagnolet Gallieni", "Noisy-le-Grand centre"],
    mapEmbed: "https://www.google.com/maps?q=Seine-Saint-Denis%2C%20France&z=10&output=embed",
    contexte: "département nord parisien en pleine transformation",
    specificites: "mix d'habitat social, immeubles anciens, nouvelles copropriétés (Grand Paris Express), fort volume d'appels urgents",
  },
  "val-de-marne": {
    code: "94",
    name: "Val-de-Marne",
    label: "Val-de-Marne (94)",
    prep: "dans le Val-de-Marne",
    hero: "dans le Val-de-Marne",
    region: "Île-de-France",
    cities: [
      "Créteil", "Vitry-sur-Seine", "Champigny-sur-Marne", "Saint-Maur-des-Fossés", "Ivry-sur-Seine",
      "Villejuif", "Fontenay-sous-Bois", "Cachan", "Charenton-le-Pont", "Nogent-sur-Marne",
      "Choisy-le-Roi", "Alfortville", "Maisons-Alfort", "Le Kremlin-Bicêtre", "Thiais",
      "Vincennes", "Saint-Mandé", "Sucy-en-Brie", "Orly", "Boissy-Saint-Léger",
    ],
    quartiers: ["Créteil L'Échat", "Vincennes centre", "Ivry-Port", "Saint-Maur des Fossés", "boucles de la Marne"],
    mapEmbed: "https://www.google.com/maps?q=Val-de-Marne%2C%20France&z=10&output=embed",
    contexte: "département sud-est francilien, mélange pavillons et immeubles",
    specificites: "petites copropriétés, pavillons de banlieue proche, secteur hospitalier (CHU Créteil), forte activité résidentielle",
  },
  "val-d-oise": {
    code: "95",
    name: "Val-d'Oise",
    label: "Val-d'Oise (95)",
    prep: "dans le Val-d'Oise",
    hero: "dans le Val-d'Oise",
    region: "Île-de-France",
    cities: [
      "Cergy", "Argenteuil", "Sarcelles", "Franconville", "Ermont",
      "Garges-lès-Gonesse", "Bezons", "Herblay-sur-Seine", "Villiers-le-Bel", "Goussainville",
      "Gonesse", "Pontoise", "Éragny", "Saint-Ouen-l'Aumône", "Taverny",
      "Osny", "Enghien-les-Bains", "Domont", "L'Isle-Adam", "Persan",
    ],
    quartiers: ["Cergy-Préfecture", "Argenteuil centre", "Enghien-les-Bains", "vallée de Montmorency", "Roissy CDG proche"],
    mapEmbed: "https://www.google.com/maps?q=Val-d'Oise%2C%20France&z=10&output=embed",
    contexte: "département nord-ouest francilien, mixte pavillons et villes nouvelles",
    specificites: "villes nouvelles (Cergy), zones pavillonnaires, résidences années 70, proximité aéroport Roissy CDG",
  },
};

export const DEPT_SLUGS = Object.keys(DEPARTMENTS);

// 3 métiers × 8 départements = 24 combinaisons
export const METIERS = {
  plomberie: {
    slug: "plombier",
    label: "Plombier",
    labelLower: "plombier",
    category: "plomberie",
    icon: "Droplets",
    image: "/images/plomberie.jpg",
    color: "brand",
  },
  serrurerie: {
    slug: "serrurier",
    label: "Serrurier",
    labelLower: "serrurier",
    category: "serrurerie",
    icon: "KeyRound",
    image: "/images/serrurerie.jpg",
    color: "brand-green",
  },
  electricite: {
    slug: "electricien",
    label: "Électricien",
    labelLower: "électricien",
    category: "electricite",
    icon: "Zap",
    image: "/images/electricite.jpg",
    color: "brand",
  },
};

// Helper -> génère toutes les combinaisons (pour routing + sitemap)
export const DEPT_ROUTES = [];
Object.values(METIERS).forEach((m) => {
  DEPT_SLUGS.forEach((deptSlug) => {
    DEPT_ROUTES.push({
      path: `/${m.slug}-${deptSlug}`,
      metier: m.category,
      deptSlug,
    });
  });
});
